import React from 'react';
import { Identifier, PublicFieldProps, useLocale } from 'react-admin';
import ReportLink from '../ReportLink';
import { getIdunoxReportUrl } from '../../utils/requests';

// The report is signed per click so the URL carries the language the doctor
// currently has selected.
const IdunoxReportLink = ({
  testId,
  className,
}: PublicFieldProps & { testId: Identifier }) => {
  const locale = useLocale();

  return (
    <ReportLink
      className={className}
      fetchUrl={() => getIdunoxReportUrl(String(testId), locale)}
      linkText="testResults.openIdunoxReport"
      errorMessage="testResults.idunoxReportError"
    />
  );
};

export default IdunoxReportLink;
